import type { WidgetMeta, WidgetRegistryEntry } from "@/types/widget";
import type { ComponentType } from "react";

import { KpiSummaryWidget } from "./kpi-summary/KpiSummaryWidget";
import { TopPirateServicesWidget } from "./top-pirate-services/TopPirateServicesWidget";
import { DetectionTimelineWidget } from "./detection-timeline/DetectionTimelineWidget";
import { InfringementTypesWidget } from "./infringement-types/InfringementTypesWidget";
import { InfringementsTableWidget } from "./infringements-table/InfringementsTableWidget";
import { EdrStatusWidget } from "./edr-status/EdrStatusWidget";
import { EdrVolumeWidget } from "./edr-volume/EdrVolumeWidget";

const componentMap: Record<string, ComponentType> = {
  kpi_summary: KpiSummaryWidget,
  chart_top_pirates: TopPirateServicesWidget,
  chart_detection_timeline: DetectionTimelineWidget,
  chart_infringement_types: InfringementTypesWidget,
  table_infringements: InfringementsTableWidget,
  kpi_edr_status: EdrStatusWidget,
  chart_edr_volume: EdrVolumeWidget,
};

const widgetsMeta: WidgetMeta[] = [
  {
    id: "kpi_summary",
    title: "Infringement Summary",
    description: "Total with critical, pending and resolved breakdown",
    category: "kpi",
    icon: "LayoutDashboard",
    defaultW: 3,
    defaultH: 4,
    minW: 2,
    minH: 3,
    hideHeader: true,
  },
  {
    id: "chart_infringement_types",
    title: "Infringement Types",
    description: "Treemap breakdown by infringement category",
    category: "chart",
    icon: "PieChart",
    defaultW: 4,
    defaultH: 4,
    minW: 3,
    minH: 4,
    hideHeader: true,
  },
  {
    id: "chart_top_pirates",
    title: "Top Pirate Services",
    description: "Bar chart of top offending pirate services",
    category: "chart",
    icon: "BarChart2",
    defaultW: 5,
    defaultH: 4,
    minW: 3,
    minH: 4,
    hideHeader: true,
  },
  {
    id: "chart_detection_timeline",
    title: "Detection / Response",
    description: "Detection and response time across events",
    category: "chart",
    icon: "LineChart",
    defaultW: 12,
    defaultH: 6,
    minW: 3,
    minH: 4,
    hideHeader: true,
  },
  {
    id: "table_infringements",
    title: "Infringements",
    description: "Searchable table of all infringement records",
    category: "table",
    icon: "Table",
    defaultW: 12,
    defaultH: 9,
    minW: 6,
    minH: 5,
    hideHeader: true,
  },
  {
    id: "kpi_edr_status",
    title: "EDR Status",
    description: "Status of each active EDR with associated detections and actions",
    category: "kpi",
    icon: "Activity",
    defaultW: 4,
    defaultH: 5,
    minW: 3,
    minH: 4,
    hideHeader: true,
  },
  {
    id: "chart_edr_volume",
    title: "EDR Activity",
    description: "Detection timeline per EDR — confirms data is flowing normally",
    category: "chart",
    icon: "BarChart3",
    defaultW: 6,
    defaultH: 5,
    minW: 3,
    minH: 4,
    hideHeader: true,
  },
];

const entries: WidgetRegistryEntry[] = widgetsMeta.map((meta) => ({
  meta,
  component: componentMap[meta.id],
}));

export const widgetRegistry: Map<string, WidgetRegistryEntry> = new Map(
  entries.map((e) => [e.meta.id, e]),
);

export const allWidgets = entries;
